import React, { useEffect } from 'react'
import { Link, NavLink } from "react-router-dom";

import NavBar from '../Common/Navbar';
import ServicesCard from '..//Home/ServicesCard';
import card4 from '../../assets/Images/slider4.png';
import card5 from '../../assets/Images/slider5.png';
import card6 from '../../assets/Images/slider6.png';
import card7 from '../../assets/Images/slider7.png';
import card8 from '../../assets/Images/slider8.png';
import card9 from '../../assets/Images/slider9.png';
import { FaArrowRight } from "react-icons/fa";
import Experience from '../Home/Experience';
import ExperienceContent from '../Home/ExperienceContent';
import Work from '../Home/Work';
import FooterMenu from '../Common/FooterMenu';
import Copyright from '../Common/Copyright';
import TopButton from '..//Home/TopButton';


function Services() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <div className='header-about'>
                <NavBar />
                <div className="container text-center cont-sec">
                    <h2>We Do Everything</h2>
                    <div className="d-flex align-items-center justify-content-center">
                        <Link to = "/">Home</Link>
                        <span>//</span>
                        <Link to = "/service">Services</Link>
                    </div>
                </div>
            </div>
            <div style={{ background: '#150725', padding: '120px 0 120px 0' }}>
                <ServicesCard />
                <div className="container">
                    <div className="d-flex align-items-center justify-content-center gap-4">
                    <div className="service-card">
                            <figure className='d-flex align-items-center justify-content-center'>
                                <img src={card9} alt="card9.img" style={{ color: '#d3c9c1' }} />
                            </figure>
                            <h3>Branding</h3>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</p>
                            <Link to = "/service" className='d-flex align-items-center'>
                                Read more <FaArrowRight style={{ color: '#ffffff' }} />
                            </Link>
                        </div>
                        <div className="service-card mb-4">
                            <figure className='d-flex align-items-center justify-content-center'>
                                <img src={card5} alt="card5.img" style={{ color: '#d3c9c1' }} />
                            </figure>
                            <h3>SEO</h3>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</p>
                            <Link to = "/service" className='d-flex align-items-center'>
                                Read more <FaArrowRight style={{ color: '#ffffff' }} />
                            </Link>
                        </div>
                        <div className="service-card mb-4">
                            <figure className='d-flex align-items-center justify-content-center'>
                                <img src={card6} alt="card6.img" style={{ color: '#d3c9c1' }} />
                            </figure>
                            <h3>Digital Marketing</h3>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</p>
                            <Link to = "/service" className='d-flex align-items-center'>
                                Read more <FaArrowRight style={{ color: '#ffffff' }} />
                            </Link>
                        </div>
                    </div>
                </div>
                {/* <div className="container">
                    <div className="d-flex align-items-center justify-content-center gap-4">
                        <div className="service-card">
                            <figure className='d-flex align-items-center justify-content-center'>
                                <img src={card7} alt="card7.img" style={{ color: '#d3c9c1' }} />
                            </figure>
                            <h3>UI/UX Design</h3>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</p>
                            <Link to = "/service" className='d-flex align-items-center'>
                                Read more <FaArrowRight style={{ color: '#ffffff' }} />
                            </Link>
                        </div>
                        <div className="service-card">
                            <figure className='d-flex align-items-center justify-content-center'>
                                <img src={card8} alt="card8.img" style={{ color: '#d3c9c1' }} />
                            </figure>
                            <h3>Web Development</h3>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</p>
                            <Link to = "/service" className='d-flex align-items-center'>
                                Read more <FaArrowRight style={{ color: '#ffffff' }} />
                            </Link>
                        </div>
                        <div className="service-card">
                            <figure className='d-flex align-items-center justify-content-center'>
                                <img src={card9} alt="card9.img" style={{ color: '#d3c9c1' }} />
                            </figure>
                            <h3>Branding</h3>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</p>
                            <Link to = "/service" className='d-flex align-items-center'>
                                Read more <FaArrowRight style={{ color: '#ffffff' }} />
                            </Link>
                        </div>
                    </div>
                </div> */}
            </div>
            <div className='experience'>
                <Experience />
                <ExperienceContent />
            </div>
            <Work />
            <FooterMenu />
            <Copyright />
            <TopButton />
        </>
    )
}

export default Services
